import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import ICU from 'i18next-icu'
import frTranslations from './translations/fr.json'
import enTranslations from './translations/en.json'
import { setLocaleInHeaders } from './utils/http.util'
import dayjs from 'dayjs'
import 'dayjs/locale/en'
import 'dayjs/locale/en-gb'
import 'dayjs/locale/es'
import 'dayjs/locale/fr'
import 'dayjs/locale/pl'

i18n
  .use(ICU) // Add ICU MessageFormat support (for {variable, select, ...} syntax)
  .use(initReactI18next)
  .init({
    showSupportNotice: false,
    resources: {
      fr: {
        translation: frTranslations,
      },
      en: {
        translation: enTranslations,
      },
    },
    lng: 'fr', // Default language
    fallbackLng: 'fr',
    interpolation: {
      escapeValue: false, // React already escapes
    },
    i18nFormat: {
      // ICU options (optional)
      memoize: true,
    },
  })

// Set initial locale in HTTP headers and dayjs
setLocaleInHeaders(i18n.language)
dayjs.locale(i18n.language)

// Update locale in HTTP headers and dayjs when language changes
i18n.on('languageChanged', (lng) => {
  setLocaleInHeaders(lng)
  dayjs.locale(lng)
})

export default i18n
